import { Observable } from 'rxjs'
import { Order, DeliveryStatus, Ticket, OrderData, PageableSearch } from "../../models"
import { OrderActions } from './order.actions';

export interface OrderState {
	order: Order,
	deliveryStatus: DeliveryStatus,
	tickets: Ticket[],
	orderSearch: PageableSearch<OrderData>,
	showDisplayOrderSpinner: boolean,
	showPrintSpinner: boolean
};

const initialState: OrderState = {
	order: null,
	deliveryStatus: null,
	tickets: [],
	orderSearch: {
		content: [],
		first: false,
		last: false,
		number: 0,
		numberOfElements: 0,
		size: 0,
		totalElements: 0,
		totalPages: 0
	},
	showPrintSpinner: false,
	showDisplayOrderSpinner: false
}


export const orderReducer = (state = initialState, action): OrderState => {
	switch (action.type) {
		case OrderActions.GET_ORDER_BY_UUID_SUCCESS: {
			return Object.assign({}, state, {order: action.payload})
		}
		case OrderActions.GET_DELIVERY_STATUS_SUCCESS: {
			return Object.assign({}, state, {deliveryStatus: action.payload})
		}
		case OrderActions.GET_TICKETS_SUCCESS: {
			return Object.assign({}, state, {tickets: action.payload})
		}
		case OrderActions.PRINT_TICKETS: {
			return Object.assign({}, state,
				{
					showPrintSpinner: true
				})
		}
		case OrderActions.SEND_EMAIL: {
			return Object.assign({}, state,
				{
					showPrintSpinner: true
				})
		}
		case OrderActions.REMOVE_PRINT_SPINNER: {
			return Object.assign({}, state,
				{
					showPrintSpinner: false
				})
		}
		case OrderActions.ORDER_SEARCH_SUCCESS: {
			return Object.assign({}, state,
				{
					orderSearch: action.payload,
					showDisplayOrderSpinner: false
				})
		}

		case OrderActions.ORDER_SEARCH: {
			return Object.assign({}, state,
				{
					showDisplayOrderSpinner: true
				})
		}

		default: return state;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/order-components/order.reducer.ts